import clsx from 'clsx';
import type { ElementType, HTMLAttributes, ReactNode } from 'react';

import styles from '@/app/cc/_component/ui/common/Text/Text.module.scss';

type TypographyCategory = 'display' | 'title' | 'heading' | 'body' | 'caption' | 'button';

type Props = HTMLAttributes<HTMLElement> & {
  readonly as?: ElementType; // 기본값: span
  readonly category?: TypographyCategory;
  readonly variant?: string;
  readonly children: ReactNode;
  readonly color?: string; // 옵션: 색상 지정을 위해 추가 가능
};

export default function Text(props: Props) {
  const {
    as: Component = 'span',
    category = 'body',
    variant = 'r2',
    children,
    className,
    style,
    color,
    ...rest
  } = props;

  const variantClass = styles[`${category}-${variant}`];

  return (
    <Component className={clsx(styles.text, variantClass, className)} style={{ color, ...style }} {...rest}>
      {children}
    </Component>
  );
}
